export default __webpack_public_path__ + "static/media/double-caret-left.d61f9aa1.svg";